import { authLayout, adminLayout } from "../helpers/withAuth";

export const userRoutes = {
  path: "users",
  ...authLayout("user management", [
    {
      path: "/users/",
      lazy: () =>
        import("../../modules/account-manaement/users").then((m) => ({
          Component: m.default,
        })),
    },
  ]),
};

export const permissionRoutes = {
  path: "permissions",
  ...authLayout("Permissions management", [
    {
      path: "/permissions/",
      lazy: () =>
        import("../../modules/account-manaement/permissions").then((m) => ({
          Component: m.default,
        })),
    },
  ]),
};

export const roleRoutes = {
  path: "roles",
  ...authLayout("role management", [
    {
      path: "/roles/",
      lazy: () =>
        import("../../modules/account-manaement/roles").then((m) => ({
          Component: m.default,
        })),
    },
  ]),
};

export const teamRoutes = {
  path: "teams",
  ...authLayout("Teams management", [
    {
      path: "/teams/",
      lazy: () =>
        import("../../modules/account-manaement/organizations").then((m) => ({
          Component: m.default,
        })),
    },
  ]),
};

export const auditRoutes = {
  path: "audit",
  ...authLayout("Audit Logs", [
    {
      path: "/audit/",
      lazy: () =>
        import("../../modules/control-panel/audit-logs").then((m) => ({
          Component: m.default,
        })),
    },
  ]),
};

export const monitoringRoutes = {
  path: "platformjobstate",
  ...authLayout("Platform Job State", [
    {
      path: "/platformjobstate/",
      lazy: () =>
        import("../../modules/monitoring/job-states").then((m) => ({
          Component: m.default,
        })),
    },
  ]),
};

export const controlPanelRoutes = {
  path: "control-panel",
  ...adminLayout("Control Panel", [
    {
      path: "/control-panel/triggers",
      lazy: () =>
        import("../../modules/control-panel/triggers").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/control-panel/tag-editor",
      lazy: () =>
        import("../../modules/control-panel/tag-editor").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/control-panel/audit-logs",
      lazy: () =>
        import("../../modules/control-panel/audit-logs").then((m) => ({
          Component: m.default,
        })),
    },
  ]),
};
